export default import.meta.ROLLDOWN_FILE_URL_NJoGPgDQwNEm7BbXfid6Tw